var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.428,
    height: 17.599,
    viewBox: "0 0 17.428 17.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10852",
    "data-name": "Path 10852",
    className: "a",
    d: "M17.487,6.677l1.087,1.087L7.606,18.731,3.495,19.888l-.274-.148a1.627,1.627,0,0,1-.65-.634l-.163-.277L3.532,14.61,14.476,3.666l1.087,1.087L4.911,15.4l-.716,2.689L6.8,17.36ZM16.37,3.827,18.3,5.789l1.1-1.077L17.467,2.75l-.942.926.943-.927a1.537,1.537,0,0,0-2.175-.017S16.372,3.826,16.37,3.827Zm3.026.884L18.3,5.788l1.076,1.1A1.537,1.537,0,0,0,19.4,4.712Z",
    transform: "translate(-2.408 -2.289)",
    fill: "#0071b9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.08ea26f8.svg";
export { ForwardRef as ReactComponent };